// extracted by mini-css-extract-plugin
export default {"ConfirmDialog":"ConfirmDialog_ConfirmDialog__VWP3i","large-button":"ConfirmDialog_large-button__Pw-ou"};